import classnames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import { FC, useMemo } from 'react';
import styled from 'styled-components';

export interface ConfirmationBannerProps {
  cancelButtonText: IntlKey;
  className?: string;
  color?: 'success' | 'danger' | 'warning' | 'info';
  confirmButtonText: IntlKey;
  e2e?: string;
  icon?: string;
  message: IntlKey;
  onCancel?: () => void;
  onConfirm?: () => void;
}

export const StyledConfirmationBannerContainer = styled.div`
  z-index: 1;
`;

export const ConfirmationBanner: FC<ConfirmationBannerProps> = ({
  cancelButtonText,
  className,
  color = 'info',
  confirmButtonText,
  e2e,
  icon = 'info_outline',
  message,
  onCancel,
  onConfirm,
}) => {
  const containerClasses = useMemo(
    () => classnames('confirmation-banner-component', 'card', 'text-primary-alt', `bg-${color}`, className),
    [color, className],
  );
  const cancelButtonClasses = useMemo(() => classnames('btn', 'btn-lg', `btn-${color}`, 'ms-1'), [color]);

  return (
    <StyledConfirmationBannerContainer className={containerClasses} data-e2e={e2e}>
      <div className="card-body">
        <div className="card-text d-flex align-items-center">
          <i className="icon icon-md me-2">{icon}</i>

          <div className="flex-grow-1">
            <FormattedMessage id={message} defaultMessage={message} />
          </div>

          <button
            type="button"
            className="btn btn-lg btn-black ms-1"
            onClick={onConfirm}
            data-e2e="confirmation-banner-confirm-button"
          >
            <FormattedMessage id={confirmButtonText} defaultMessage={confirmButtonText} />
          </button>
          <button
            type="button"
            className={cancelButtonClasses}
            onClick={onCancel}
            data-e2e="confirmation-banner-cancel-button"
          >
            <FormattedMessage id={cancelButtonText} defaultMessage={cancelButtonText} />
          </button>
        </div>
      </div>
    </StyledConfirmationBannerContainer>
  );
};
